import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {WithConsent} from '../../WithConsent';
import {TextSkeleton} from 'components/primitives/bodySkeleton';
import {Subtitle} from 'components/primitives/subtitle';
import {Caption} from 'components/primitives/caption';
import {grey} from 'components/primitives/color';
import Columns from 'components/layout/Columns';
import {Button} from 'components/buttons/Button';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {OutlinedButton} from 'components/buttons/Button';
import {CaptionSkeleton} from 'components/primitives/captionSkeleton';
import {TextButton} from '../../../../components/buttons/TextButton';


export class Acceptor extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        linkToFull: PropTypes.string,
        onChange: PropTypes.func,
        onReset: PropTypes.func,
        consent: PropTypes.shape({
            revision: PropTypes.string.isRequired,
            shortDescription: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired
        }).isRequired,
        consentState: PropTypes.shape({
            type: PropTypes.string,
            accepted: PropTypes.bool,
            revision: PropTypes.string
        })
    };
    renderDescription = () => {
        return (
            <Text>
                <Title>
                    <Subtitle bold={true}>
                        {this.props.consent.title}
                    </Subtitle>
                </Title>
                <ShortDescription>
                    <Caption>
                        {this.props.consent.shortDescription}&nbsp;
                        <a target='_blank' rel='noopener noreferrer' href={this.props.linkToFull}>
                            <FormattedMessage {...messages.moreInfo}/>
                        </a>
                    </Caption>
                </ShortDescription>
            </Text>
        );
    };

    callOnChange = (checked) => {
        this.props.onChange({
            type: this.props.type,
            accepted: checked,
            revision: this.props.consent.revision
        });
    };

    renderButtons = () => {
        const {consentState, onReset, type} = this.props;
        if (!consentState) {
            return (
                <Buttons>
                    <Button onClick={() => this.callOnChange(true)}>
                        <FormattedMessage {...messages.allow}/>
                    </Button>
                    <TextButton onClick={() => this.callOnChange(false)}>
                        <FormattedMessage {...messages.deny}/>
                    </TextButton>
                </Buttons>
            );
        }

        const message = consentState.accepted ? messages.allowed : messages.denied;
        return (
            <Buttons>
                <OutlinedButton onClick={() => onReset(type)}>
                    <FormattedMessage {...message}/>
                </OutlinedButton>
            </Buttons>
        );
    };

    render() {
        return (
            <Wrapper>
                <Columns columns={[{
                    size: 8,
                    render: this.renderDescription
                }, {
                    size: 4,
                    shrink: false,
                    grow: false,
                    render: this.renderButtons
                }]}/>

            </Wrapper>
        );
    }
}

export class AcceptConsentLarge extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        linkToFull: PropTypes.string,
        onChange: PropTypes.func,
        onReset: PropTypes.func,
        consentState: PropTypes.shape({
            type: PropTypes.string,
            accepted: PropTypes.bool,
            revision: PropTypes.string
        })
    };

    static defaultProps = {
        onChange: () => undefined
    };

    renderAcceptSkeleton = () => {
        return (
            <Text>
                <Title>
                    <TextSkeleton/>
                </Title>
                <ShortDescription>
                    <CaptionSkeleton/>
                </ShortDescription>
            </Text>
        );
    };

    render() {
        return (
            <WithConsent type={this.props.type}>
                {({loading, consent}) => (
                    loading ?
                        this.renderAcceptSkeleton() :
                        <Acceptor
                            consent={consent}
                            type={this.props.type}
                            onChange={this.props.onChange}
                            linkToFull={this.props.linkToFull}
                            consentState={this.props.consentState}
                            onReset={this.props.onReset}
                        />
                )}
            </WithConsent>
        );
    }
}

const Wrapper = styled.div`
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${grey.grey600};
  
  &:first-child {
    margin-top: 0;
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Text = styled.div`
`;

const Title = styled.div`
  line-height: 16px;
`;

const ShortDescription = styled.div`
  line-height: 14px;
  margin-top: 4px;
`;


export default AcceptConsentLarge;
